import ClubItemBase from "./club_item_base";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubGameInfo extends ClubItemBase {

    @property(cc.Sprite)
    gameIcon: cc.Sprite = null;

    @property(cc.Label)
    gameName: cc.Label = null;

    @property(cc.Label)
    onlineNum : cc.Label = null;

    @property(cc.Label)
    tableNum : cc.Label = null;

    @property(cc.Label)
    rank : cc.Label = null;

    onSetting(){

        this.dispatchEvent("club_set_game_content",this.itemIndex);
    }

    refresh(){

        this.rank.string = (this.itemIndex + 1).toString();
    }

}
